import { ref } from "vue";
import { useStore } from "@/store";
const store = useStore();
const activeRowModal: any = ref({ data: null });
import { GeneralActionTypes } from "@/store/modules/general/action-types";

function getAccessControlById(value: number): string | undefined {
    const store = useStore()
    const accessControlOptions = store.state.general.enums?.['GlobalAccessControl'] || []
    const item = accessControlOptions.find((x: any) => x.value === value)
    return item?.label
}

function getFolderNameById(value: number): string | undefined {
    const folderMaps = store.state.general.folderMaps as { label: string; value: number }[];
    const folder = folderMaps.find((item: any) => item.value === value);
    return folder?.label;
}

const data = {
    filter: {
        title: "fileAccessfilter",
        pageName: "fileAccessfilter",
        genre: "fileAccessPageFilter",
        ignoreSaveFilter: true,
        noDateSelect: true,
        hideFilter: false,
        //quickSearch: "fullTextSearch",
        filters: [
        ],
    },
    header: {
        navigation: [

        ],
        buttonPosition: "pr-4 justify-content-between",
        buttons: [

        ],
    },
    component: {
        type: "ag-table",
        options: {
            columns: [
                {
                    label: "PATH",
                    field: "fileName",
                    sortable: true,
                    jsSort: true,
                    display: (row: any) => {
                        const path = row.fileName ?? "";
                        const hasFolderMap = row.folderMapId !== null && row.folderMapId !== undefined;
                        const folderMap = hasFolderMap ? (getFolderNameById(row.folderMapId) ?? "") : "";
                        const fullPath = !hasFolderMap && row.isFolderMapIdAny
                            ? `*\\${path}`
                            : (folderMap && path
                                ? `${folderMap}\\${path}`
                                : `${folderMap}${path}`);
                        let html = "<div class='d-flex flex-column align-items-start'>";
                        html += "<span style='color: #01172F; font-weight: bold; ' >" + fullPath + "</span>"
                        if (row.enabled === false) {
                            html += "<div class='d-flex align-items-center' style='margin-top:10px'><i class='ag-icon ag-icon_warning_filled' style='font-size:0.8em !important;'></i><span style='font-size:0.7em; color:#636363;'>This rule is disabled and will not be published</span></div>";
                        }
                        html += "</div>";
                        return html;
                    },
                    width: "50%",
                },
                {
                    label: "ACCESS CONTROL",
                    field: "accessControl",
                    display: (row: any) => {
                        const accessControl = row.accessControl ? getAccessControlById(row.accessControl) : "";
                        return `<span style='color: #01172F;'>${accessControl}</span>`;
                    },
                    sortable: true,
                    jsSort: true,
                    width: "30%",
                },
                {
                    label: "ACTION",
                    field: "commands",
                    components: [
                        {
                            component: "appGroupTableEditComponent",
                        },
                        {
                            component: "copyAction",
                            class: "mr-2 ml-2",
                        },
                        {
                            component: "appGroupDeleteComponent",
                        },
                    ],
                    width: "120px",

                },
            ],
            rows: [],
            total: 0,
            sortable: {
                order: "",
                sort: "asc",
            },
            page: 0,
            pageSize: 0,
            isLoading: true,
            showPagination: false,
            dateFilter: false,
            zebra: true,
            separateBorders: true,
            editOnRowClick: true,
            fetchTable: (options: any) => {
                store.dispatch(GeneralActionTypes.GET_GLOBAL_POLICY_FILE_ACCESS, {
                    options: options,
                    filters: {}
                });
            }
        },
    },

};

export default data;
